// The SDK session is separate from Maui authentication. Keep signing requests
// from resurrecting it after logout, even while the SDK is still loading.
let bootGeneration = 0
let terminationGeneration = 0

type IntercomWindow = Window & { Intercom?: (command: string) => void }

export const getIntercomBootGeneration = () => bootGeneration
export const getSessionTerminationGeneration = () => terminationGeneration

export const resetIntercomSession = () => {
  bootGeneration += 1
  const intercom = (window as IntercomWindow).Intercom
  try {
    if (typeof intercom === 'function') intercom('shutdown')
  } catch {
    // Cookie cleanup and Maui logout must proceed if a third-party SDK throws.
  } finally {
    // Also clear the cookie when the script has not loaded yet. Delete only
    // this workspace's authentication cookie, including parent-domain copies.
    const appId = window.CONFIG?.INTERCOM_APP_ID
    if (appId) {
      const key = `intercom-session-${appId}`
      document.cookie = `${key}=; Max-Age=0; Path=/`
      const labels = (window.location.hostname || '').split('.')
      for (let i = 0; i < labels.length - 1; i += 1) {
        document.cookie = `${key}=; Max-Age=0; Path=/; Domain=${labels
          .slice(i)
          .join('.')}`
      }
    }
  }
}

export const endIntercomSession = () => {
  terminationGeneration += 1
  resetIntercomSession()
}
